/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for common account services/utilities.
 */
'use strict';

angular
  .module('services.account', [])
  /**
   * A factory with common account utilities.
   */
  .factory('accountUtils', function (httpAccount, $q) {
    return {
      /**
       * Org info object.
       */
      orgInfo: {},

      /**
       * Getter method for the orgInfo object. It will only get the
       * orgInfo object from the server when it has not previously been
       * retrieved.
       *
       * @params {Boolean} [forceReload=false] - Optional. Force a reload of the org object.
       * @returns {Promise} A promise that resolved into the orgInfo object.
       */
      getOrgInfo: function (forceReload) {
        var deferred = $q.defer(),
          self = this;
        forceReload = forceReload || false;
        // If orgInfo has never been populated then make the http
        // call to populate it.
        if (_.isEmpty(self.orgInfo) || forceReload) {
          httpAccount.getOrg().then(function (org) {
            self.orgInfo = org;
            deferred.resolve(org);
          });
        } else {
          deferred.resolve(self.orgInfo);
        }
        return deferred.promise;
      },

      /**
       * Get the current account status.
       *
       * @returns {Promise} - A promise that resolves into a account status object.
       */
      getAccountStatus: function () {
        return httpAccount.getAccountStatus();
      },

      logout: () => {
        return httpAccount.logout();
      }
    };
  });
